/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { RejectConfirmModal, InformModal, StateSelect, ZipCodeInput, ESignModal, PhoneInput } from '../common/SharedComponents';
import { phoneTypes, brokerTitles } from '../common/SharedConstants';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { connect, useSelector } from 'react-redux';
import store, { brokerActions, bfiUserActions, userActions } from '@apply/adminStore';
import { ConfirmModal, formatDateTime, hasPermission } from '@apply/ui';
import { RefreshEvents } from '../common/SharedEvents';
import { BrokerApi, ListApi, TemplatesApi, LoginApi } from '@apply/api';
import { applicationInsights } from '../ApplicationInsights';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import BrokerClientsTable from './tables/BrokerClientsTable';
import { handleAdminError, handleAdminInfo, handleAdminSuccess } from '../common/SharedFunctions';
import { BrokerStatusType, BrokerStatusTypeOptions, PermissionType } from '@apply/constants';
import UserAgreementsTable from '../user/tables/UserAgreementsTable';
import { BfiDataGrid, Column, formatPhone } from '@apply/ui';
import { GridSettingType } from '@apply/constants';
import { LoadPanel } from 'devextreme-react/load-panel';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';

const RED_TEXT = '#E00400';
const BLACK_TEXT = '#292e30';

const displayInRedIfDifferent = (newVal, oldVal, id) => {
    const element = document.getElementById(id);
    if (!element || !newVal) {
        return;
    }
    if (newVal !== oldVal) {
        element.style.color = RED_TEXT;
    } else {
        element.style.color = BLACK_TEXT;
    }
};

const shallowEqual = (object1, object2) => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            if (
                Object.prototype.toString.call(object1[key]) === '[object Date]' &&
                Object.prototype.toString.call(object2[key]) === '[object Date]'
            ) {
                if (object1[key].getTime() !== object2[key].getTime()) {
                    return false;
                }
            } else {
                return false;
            }
        }
    }
    return true;
};

const ContactAddress = ({ id, address, brokerStatus, lastEditJson, bfiUser, onChange, highlightDiffs }) => {
    const [address1, set_address1] = React.useState('');
    const [address2, set_address2] = React.useState('');
    const [city, set_city] = React.useState('');
    const [state, set_state] = React.useState('');
    const [zipCode, set_zipCode] = React.useState('');
    const [phoneNumberA, set_phoneNumberA] = React.useState('');
    const [phoneNumberB, set_phoneNumberB] = React.useState('');
    const [phoneNumberAType, set_phoneNumberAType] = React.useState('');
    const [phoneNumberBType, set_phoneNumberBType] = React.useState('');
    const [email, set_email] = React.useState('');
    const [secondaryEmail, set_secondaryEmail] = React.useState('');

    const createAddress = () => {
        return {
            address1,
            address2,
            city,
            state,
            zipCode,
            phoneNumberA,
            phoneNumberAType,
            phoneNumberB,
            phoneNumberBType,
            email,
            secondaryEmail,
        };
    };

    useEffect(() => {
        if (
            !address &&
            !address1 &&
            !address2 &&
            !city &&
            !state &&
            !zipCode &&
            !phoneNumberA &&
            !phoneNumberB &&
            !phoneNumberAType &&
            !phoneNumberBType &&
            !email &&
            !secondaryEmail
        ) {
            return;
        }

        highlightChangedValues(brokerStatus, lastEditJson);

        const newAddress = createAddress();
        onChange(newAddress);
    }, [
        address1,
        address2,
        city,
        state,
        zipCode,
        phoneNumberA,
        phoneNumberB,
        phoneNumberAType,
        phoneNumberBType,
        email,
        secondaryEmail,
    ]);

    useEffect(() => {
        if (!address) {
            return;
        }
        set_address1(address?.address1 ?? '');
        set_address2(address?.address2 ?? '');
        set_city(address?.city ?? '');
        set_state(address?.state ?? '');
        set_zipCode(address?.zipCode ?? '');
        set_phoneNumberA(address?.phoneNumberA ?? '');
        set_phoneNumberB(address?.phoneNumberB ?? '');
        set_phoneNumberAType(address?.phoneNumberAType ?? '');
        set_phoneNumberBType(address?.phoneNumberBType ?? '');
        set_email(address?.email ?? '');
        set_secondaryEmail(address?.secondaryEmail ?? '');
    }, [address]);

    useEffect(() => {
        if (!lastEditJson) {
            return;
        }
        highlightChangedValues(brokerStatus, lastEditJson);
    }, [highlightDiffs, lastEditJson, brokerStatus]);

    const highlightChangedValues = (brokerStatus, lastEditJson) => {
        if (brokerStatus !== BrokerStatusType.Pending && brokerStatus !== BrokerStatusType.InviteAccepted) return;
        if (!lastEditJson) return;

        const reviewedElements = JSON.parse(lastEditJson);

        displayInRedIfDifferent(address1, reviewedElements.streetAddress, 'cAddress1');
        displayInRedIfDifferent(address2, reviewedElements.streetAddress2, 'cAddress2');
        displayInRedIfDifferent(city, reviewedElements.city, 'cCity');
        displayInRedIfDifferent(state, reviewedElements.state, 'cState');
        displayInRedIfDifferent(zipCode, reviewedElements.zipCode, 'cZipCode');
        displayInRedIfDifferent(phoneNumberA, reviewedElements.phoneNumberA, 'cPhoneNumberA');
        displayInRedIfDifferent(phoneNumberAType, reviewedElements.phoneNumberAType, 'cPhoneNumberAType');
        displayInRedIfDifferent(email, reviewedElements.email, 'cEmail');
        displayInRedIfDifferent(secondaryEmail, reviewedElements.secondaryEmail, 'cSecondaryEmail');
    };

    return (
        <div className='row'>
            <div className='columns small-12 large-6'>
                <label htmlFor='cAddress1'>
                    Street Address
                    {bfiUser.isBroker && <span className='req'>*</span>}
                </label>
                <input
                    id='cAddress1'
                    type='text'
                    value={address1}
                    onChange={(event) => set_address1(event.target.value)}
                    required={bfiUser.isBroker}
                />
                <span className='helper'>
                    <span className='tooltip-trigger'>
                        <FontAwesomeIcon icon={faCircleQuestion} />
                    </span>
                    <span className='text'>Street number and name</span>
                </span>
            </div>
            <div className='columns small-12 large-6'>
                <label htmlFor='cAddress2'>Street Address 2</label>
                <input
                    id='cAddress2'
                    type='text'
                    value={address2}
                    onChange={(event) => set_address2(event.target.value)}
                />
                <span className='helper'>
                    <span className='tooltip-trigger'>
                        <FontAwesomeIcon icon={faCircleQuestion} />
                    </span>
                    <span className='text'>Suite or unit number if applicable (e.g. 250 East 55th St., Unit 5B)</span>
                </span>
            </div>
            <div className='columns small-12 large-6'>
                <label htmlFor='cCity'>
                    City
                    {bfiUser.isBroker && <span className='req'>*</span>}
                </label>
                <input
                    id='cCity'
                    type='text'
                    value={city}
                    onChange={(event) => set_city(event.target.value)}
                    required={bfiUser.isBroker}
                />
            </div>
            <div className='columns small-12 medium-6 large-3'>
                <label htmlFor='cState'>
                    State
                    {bfiUser.isBroker && <span className='req'>*</span>}
                </label>
                <StateSelect
                    id='cState'
                    value={state}
                    onChange={(event) => set_state(event.target.value)}
                    required={bfiUser.isBroker}
                />
            </div>
            <div className='columns small-12 medium-6 large-3'>
                <label htmlFor='cZipCode'>
                    Zip Code
                    {bfiUser.isBroker && <span className='req'>*</span>}
                </label>
                <ZipCodeInput
                    id='cZipCode'
                    value={zipCode}
                    onChange={(event) => set_zipCode(event.target.value)}
                    required={bfiUser.isBroker}
                />
                <span className='helper'>
                    <span className='tooltip-trigger'>
                        <FontAwesomeIcon icon={faCircleQuestion} />
                    </span>
                    <span className='text'>Zip code, 5 or 9 digit</span>
                </span>
            </div>
            <div className='columns small-7 medium-8 large-4'>
                <label htmlFor='cPhoneNumberA'>
                    Primary Phone
                    {bfiUser.isBroker && <span className='req'>*</span>}
                </label>
                <PhoneInput
                    id='cPhoneNumberA'
                    value={phoneNumberA}
                    onChange={(value) => set_phoneNumberA(value)}
                    required={bfiUser.isBroker}
                />
                <span className='helper'>
                    <span className='tooltip-trigger'>
                        <FontAwesomeIcon icon={faCircleQuestion} />
                    </span>
                    <span className='text'>e.g. (212) 555-1212</span>
                </span>
            </div>
            <div className='columns small-5 medium-4 large-2'>
                <label htmlFor='cPhoneNumberAType'>
                    Type
                    {bfiUser.isBroker && <span className='req'>*</span>}
                </label>
                <select
                    id='cPhoneNumberAType'
                    value={phoneNumberAType}
                    onChange={(event) => set_phoneNumberAType(event.target.value)}
                    required={bfiUser.isBroker}
                >
                    <option value=''>Select</option>
                    {phoneTypes.map((type) => {
                        return (
                            <option
                                key={type}
                                value={type}
                            >
                                {type}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div className='columns small-7 medium-8 large-4'>
                <label htmlFor='cPhoneNumberB'>Secondary Phone</label>
                <PhoneInput
                    id='cPhoneNumberB'
                    value={phoneNumberB}
                    onChange={(value) => set_phoneNumberB(value)}
                    required={false}
                />
                <span className='helper'>
                    <span className='tooltip-trigger'>
                        <FontAwesomeIcon icon={faCircleQuestion} />
                    </span>
                    <span className='text'>e.g. (212) 555-1212</span>
                </span>
            </div>
            <div className='columns small-5 medium-4 large-2'>
                <label htmlFor='cPhoneNumberBType'>Type</label>
                <select
                    id='cPhoneNumberBType'
                    value={phoneNumberBType}
                    onChange={(event) => set_phoneNumberBType(event.target.value)}
                >
                    <option>Select</option>
                    {phoneTypes.map((type) => {
                        return (
                            <option
                                key={type}
                                value={type}
                            >
                                {type}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div className='columns small-12'>
                <label htmlFor='cEmail'>
                    Email Address
                    <span className='req'>*</span> (also used as Login for the account)
                </label>
                <input
                    id='cEmail'
                    type='email'
                    value={email}
                    onChange={(event) => set_email(event.target.value)}
                    required={true}
                />
                <span className='helper'>
                    <span className='tooltip-trigger'>
                        <FontAwesomeIcon icon={faCircleQuestion} />
                    </span>
                    <span className='text'>e.g. adamsmith@gmail.com</span>
                </span>
                {id > 0 && <div style={{ color: 'darkred' }}>* Changing this will also change the login for the account!</div>}
            </div>
            <div className='columns small-12'>
                <label htmlFor='cSecondaryEmail'>Alternative Email Address</label>
                <input
                    id='cSecondaryEmail'
                    type='email'
                    value={secondaryEmail}
                    onChange={(event) => set_secondaryEmail(event.target.value)}
                />
                <span className='helper'>
                    <span className='tooltip-trigger'>
                        <FontAwesomeIcon icon={faCircleQuestion} />
                    </span>
                    <span className='text'>e.g. adamsmith@gmail.com</span>
                </span>
            </div>
        </div>
    );
};

const HomeAddress = ({ address, isBrokerPending: brokerStatus, lastEditJson, bfiUser, onChange, highlightDiffs }) => {
    const [address1, set_address1] = React.useState('');
    const [address2, set_address2] = React.useState('');
    const [city, set_city] = React.useState('');
    const [state, set_state] = React.useState('');
    const [zipCode, set_zipCode] = React.useState('');
    const [dateOfBirth, set_dateOfBirth] = React.useState('');
    const [sameAsContactAddress, set_sameAsContactAddress] = React.useState(false);

    useEffect(() => {
        async function addressChanged() {
            if (!address1 && !address2 && !city && !state && !zipCode && !dateOfBirth) {
                return;
            }

            highlightChangedValues(brokerStatus, lastEditJson);

            const newAddress = createAddress();
            onChange(newAddress);
        }

        addressChanged();
    }, [address1, address2, city, state, zipCode, dateOfBirth]);

    useEffect(() => {
        async function addressChanged() {
            if (!address) {
                return;
            }

            set_address1(address?.address1 ?? '');
            set_address2(address?.address2 ?? '');
            set_city(address?.city ?? '');
            set_state(address?.state ?? '');
            set_zipCode(address?.zipCode ?? '');

            if (address?.dateOfBirth) {
                set_dateOfBirth(new Date(address.dateOfBirth));
            }

            set_sameAsContactAddress(address?.sameAsContactAddress ?? false);
        }

        addressChanged();
    }, [address]);

    useEffect(() => {
        if (!lastEditJson) {
            return;
        }
        highlightChangedValues(brokerStatus, lastEditJson);
    }, [highlightDiffs, lastEditJson, brokerStatus]);

    const createAddress = () => {
        return {
            address1,
            address2,
            city,
            state,
            zipCode,
            sameAsContactAddress,
            dateOfBirth,
        };
    };

    const onSameAddressChanged = (value) => {
        set_sameAsContactAddress(value);
        const newAddress = createAddress();
        newAddress.sameAsContactAddress = value;
        onChange(newAddress);
    };

    const today = new Date();

    const highlightChangedValues = (brokerStatus, lastEditJson) => {
        if (brokerStatus !== BrokerStatusType.Pending && brokerStatus !== BrokerStatusType.InviteAccepted) return;
        if (!lastEditJson) return;

        const reviewedElements = JSON.parse(lastEditJson);

        displayInRedIfDifferent(address1, reviewedElements.homeStreetAddress, 'hAddress1');
        displayInRedIfDifferent(address2, reviewedElements.homeStreetAddress2, 'hAddress2');
        displayInRedIfDifferent(city, reviewedElements.homeCity, 'hCity');
        displayInRedIfDifferent(state, reviewedElements.homeState, 'hState');
        displayInRedIfDifferent(zipCode, reviewedElements.homeZipCode, 'hZipCode');
        displayInRedIfDifferent(
            dateOfBirth?.getTime(),
            reviewedElements.dateOfBirth ? Date.parse(reviewedElements.dateOfBirth) : null,
            'hDateOfBirth'
        );
    };

    return (
        <>
            <div>
                <input
                    type='checkbox'
                    value={sameAsContactAddress}
                    style={{ marginRight: '5px' }}
                    onChange={() => onSameAddressChanged(!sameAsContactAddress)}
                    checked={sameAsContactAddress}
                ></input>
                Same as Contact Address
            </div>
            {!sameAsContactAddress && (
                <div className='row'>
                    <div className='columns small-12 large-6'>
                        <label htmlFor='hAddress1'>
                            Street Address
                            {bfiUser.isBroker && <span className='req'>*</span>}
                        </label>
                        <input
                            id='hAddress1'
                            type='text'
                            value={address1}
                            onChange={(event) => set_address1(event.target.value)}
                            required={bfiUser.isBroker}
                        />
                        <span className='helper'>
                            <span className='tooltip-trigger'>
                                <FontAwesomeIcon icon={faCircleQuestion} />
                            </span>
                            <span className='text'>Street number and name</span>
                        </span>
                    </div>
                    <div className='columns small-12 large-6'>
                        <label htmlFor='hAddress2'>Street Address 2</label>
                        <input
                            id='hAddress2'
                            type='text'
                            value={address2}
                            onChange={(event) => set_address2(event.target.value)}
                        />
                        <span className='helper'>
                            <span className='tooltip-trigger'>
                                <FontAwesomeIcon icon={faCircleQuestion} />
                            </span>
                            <span className='text'>Suite or unit number if applicable (e.g. 250 East 55th St., Unit 5B)</span>
                        </span>
                    </div>
                    <div className='columns small-12 large-6'>
                        <label htmlFor='hCity'>
                            City
                            {bfiUser.isBroker && <span className='req'>*</span>}
                        </label>
                        <input
                            id='hCity'
                            type='text'
                            value={city}
                            onChange={(event) => set_city(event.target.value)}
                            required={bfiUser.isBroker}
                        />
                    </div>
                    <div className='columns small-12 medium-6 large-3'>
                        <label htmlFor='hState'>
                            State
                            {bfiUser.isBroker && <span className='req'>*</span>}
                        </label>
                        <StateSelect
                            id='hState'
                            value={state}
                            onChange={(event) => set_state(event.target.value)}
                            required={bfiUser.isBroker}
                        />
                    </div>
                    <div className='columns small-12 medium-6 large-3'>
                        <label htmlFor='hZipCode'>
                            Zip Code
                            {bfiUser.isBroker && <span className='req'>*</span>}
                        </label>
                        <ZipCodeInput
                            id='hZipCode'
                            value={zipCode}
                            onChange={(event) => set_zipCode(event.target.value)}
                            required={bfiUser.isBroker}
                        />
                        <span className='helper'>
                            <span className='tooltip-trigger'>
                                <FontAwesomeIcon icon={faCircleQuestion} />
                            </span>
                            <span className='text'>Zip code, 5 or 9 digit</span>
                        </span>
                    </div>
                </div>
            )}
            <div className='row'>
                <div className='columns small-12 medium-6 large-3'>
                    <label htmlFor='hDateOfBirth'>
                        Date of Birth
                        {bfiUser.isBroker && <span className='req'>*</span>}
                    </label>
                    <DatePicker
                        id='hDateOfBirth'
                        selected={dateOfBirth}
                        onChange={(event) => set_dateOfBirth(event)}
                        maxDate={today}
                        required={bfiUser.isBroker}
                    />
                    <span className='helper'>
                        <span className='tooltip-trigger'>
                            <FontAwesomeIcon icon={faCircleQuestion} />
                        </span>
                        <span className='text'>e.g. 12/01/1995</span>
                    </span>
                </div>
            </div>
        </>
    );
};

const BrokerDetails = () => {
    const { brokerState, bfiUser, user } = useSelector((state) => state);
    const { dispatch } = store;

    const templatesApi = new TemplatesApi.TemplatesApi(applicationInsights);
    const listApi = new ListApi.ListApi(applicationInsights);
    const brokerApi = new BrokerApi.BrokerApi(applicationInsights);
    const loginApi = new LoginApi.LoginApi(applicationInsights);

    const location = useLocation();

    const refreshEvents = new RefreshEvents();
    const [headerText, set_headerText] = React.useState('');
    const [id, set_id] = React.useState(0);
    const [statusHistory, set_statusHistory] = useState([]);
    const [firstName, set_firstName] = React.useState('');
    const [lastName, set_lastName] = React.useState('');
    const [arizonaLicenseNumber, set_arizonaLicenseNumber] = React.useState('');
    const [wireBankName, set_wireBankName] = React.useState('');
    const [wireRecipientName, set_wireRecipientName] = React.useState('');
    const [wireAccountLastFourDigits, set_wireAccountLastFourDigits] = React.useState('');
    const [hasSubmittedW9, set_hasSubmittedW9] = React.useState(false);
    const [w9Url, set_w9Url] = React.useState('');
    const [businessName, set_businessName] = React.useState('');
    const [brokerFlagged, set_brokerFlagged] = React.useState(false);

    const [iccaTemplateId, set_iccaTemplateId] = React.useState('');
    const [clientFeeType, set_clientFeeType] = React.useState('');
    const [businessState, set_businessState] = React.useState('');

    const [backgroundCheckDate, set_backgroundCheckDate] = React.useState('');
    const [showBackgroundCheckDate, set_showBackgroundCheckDate] = React.useState(false);
    const [agreements, set_agreements] = React.useState([]);
    const [pointsOfContact, set_pointsOfContact] = React.useState([]);
    const [canSendTextMessages, set_canSendTextMessages] = React.useState(false);
    const [brokerStatus, set_brokerStatus] = React.useState(-1);
    const [showCompanyPanel, set_showCompanyPanel] = React.useState(false);
    const [title, set_title] = React.useState('');
    const [titleSelect, set_titleSelect] = React.useState('');
    const [showCustomTitle, set_showCustomTitle] = React.useState(false);
    const [openValidateBrokerExisting, set_openValidateBrokerExisting] = React.useState(false);
    const [openBrokerUpdateError, set_openBrokerUpdateError] = React.useState(false);
    const [openSubmitConfirm, set_openSubmitConfirm] = React.useState(false);
    const [openInformW9, set_openInformW9] = React.useState(false);
    const [acceptedTos, set_acceptedTos] = React.useState(false);
    const [eSignAgreement, set_eSignAgreement] = React.useState(false);
    const [eSignFont, set_eSignFont] = React.useState('');
    const [openESignModal, set_openESignModal] = React.useState(false);
    const [openRejectConfirm, set_openRejectConfirm] = React.useState(false);
    const [lastEditJson, set_lastEditJson] = React.useState('');
    const [brokerToSave, set_brokerToSave] = React.useState();
    const [w9FileName, set_w9FileName] = React.useState('');
    const [w9File, set_w9File] = React.useState('');
    const [pointOfContactId, set_pointOfContactId] = React.useState('');
    const [contactAddress, set_contactAddress] = React.useState(null);
    const [homeAddress, set_homeAddress] = React.useState(null);
    const [userAgreementHtml, set_userAgreementHtml] = React.useState('');

    const [highlightDiffs, set_highlightDiffs] = useState(1);

    const tabNames = ['B-Clients', 'Contact Address', 'Home Address', 'Status History', 'User Agreements'];
    const [tabIndex, set_tabIndex] = useState(1);
    const [forceValidate, set_forceValidate] = useState(false);
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [loadingMessage, set_loadingMessage] = useState('Loading...');
    const [closeOnSave, set_closeOnSave] = useState(true);

    const submitRef = useRef();
    const formRef = useRef();

    useEffect(() => {
        const eSignAgreementCheckbox = document.getElementById('eSignAgreement');
        if (eSignAgreementCheckbox) eSignAgreementCheckbox.checked = eSignAgreement;

        if (eSignAgreement) {
            set_acceptedTos(true);
        } else {
            set_acceptedTos(false);
        }
    }, [eSignAgreement]);

    const highlightChangedValues = (lastEditJson) => {
        if (brokerStatus !== BrokerStatusType.Pending) return;
        if (!lastEditJson) return;

        const reviewedElements = JSON.parse(lastEditJson);

        displayInRedIfDifferent(firstName, reviewedElements.firstName, 'firstName');
        displayInRedIfDifferent(lastName, reviewedElements.lastName, 'lastName');
        displayInRedIfDifferent(arizonaLicenseNumber, reviewedElements.arizonaLicenseNumber, 'arizonaLicenseNumber');
        displayInRedIfDifferent(wireBankName, reviewedElements.wireBankName, 'wireBankName');
        displayInRedIfDifferent(wireRecipientName, reviewedElements.wireRecipientName, 'wireRecipientName');
        displayInRedIfDifferent(
            wireAccountLastFourDigits,
            reviewedElements.wireAccountLastFourDigits,
            'wireAccountLastFourDigits'
        );
        displayInRedIfDifferent(businessName, reviewedElements.businessName, 'businessName');
        displayInRedIfDifferent(businessState, reviewedElements.businessState, 'businessState');
        displayInRedIfDifferent(title, reviewedElements.title, 'title');
    };

    const onTabClicked = (e) => {
        const index = tabNames.indexOf(e.addedItems[0].title);
        set_tabIndex(index);
        set_highlightDiffs(highlightDiffs + 1);
    };

    useEffect(() => {
        highlightChangedValues(lastEditJson);
    }, [lastEditJson]);

    useEffect(() => {
        if (acceptedTos) set_eSignAgreement(true);
    }, [acceptedTos]);

    React.useEffect(() => {
        if (!brokerToSave) return;

        if (bfiUser.admin) {
            _saveBroker();
        } else if (bfiUser.isBroker) {
            set_openSubmitConfirm(true);
        } else {
            throw new Error('User does not have permission to save Broker.');
        }
    }, [brokerToSave]);

    React.useEffect(() => {
        const getUserAgreementHtmlAsync = async () => {
            if (!userAgreementHtml) {
                const html = await getEsignHtml();
                set_userAgreementHtml(html);
            }
        };
        getUserAgreementHtmlAsync();

        if (bfiUser.isBroker) {
            dispatch(brokerActions.setBrokerId({ brokerId: bfiUser.broker.id }));
        }

        if (bfiUser.admin) {
            const loadListsAsync = async () => {
                await loadIccaTemplates();
                await _loadBfiEmployees();
            };
            loadListsAsync();
        }
    }, []);

    useEffect(() => {
        const loadBrokerAsync = async () => {
            let broker = null;
            if (brokerState.brokerId) {
                if (bfiUser.admin) {
                    const response = await brokerApi.getAdminSingleBroker(brokerState.brokerId);
                    broker = response.result;
                } else if (bfiUser.isBroker) {
                    const response = await brokerApi.getSingleBroker(brokerState.brokerId);
                    broker = response.result;
                }
            }

            if (bfiUser.isBroker) {
                set_headerText('Review Account Information');
            } else {
                set_headerText(broker ? 'Edit Broker' : 'Add Broker');
            }

            set_id(broker?.id || 0);
            set_statusHistory(broker?.statusHistory);
            set_firstName(broker?.firstName ?? '');
            set_lastName(broker?.lastName ?? '');
            set_arizonaLicenseNumber(broker?.arizonaLicenseNumber ?? '');
            set_wireBankName(broker?.wireBankName ?? '');
            set_wireRecipientName(broker?.wireRecipientName ?? '');
            set_wireAccountLastFourDigits(broker?.wireAccountLastFourDigits ?? '');
            if (broker?.iccaTemplateId) {
                set_iccaTemplateId(broker?.iccaTemplateId);
            }
            set_clientFeeType(broker?.clientFeeType ?? '');
            set_hasSubmittedW9(broker?.hasSubmittedW9 ?? false);
            set_w9Url(broker?.w9Url ?? '');

            const bs = broker?.brokerStatus ?? -1;
            set_brokerStatus(bs);
            set_tabIndex(bs === BrokerStatusType.Activated ? 0 : 1);

            set_pointOfContactId(broker?.pointOfContactId);
            set_brokerFlagged(broker?.isFlagged);

            if (broker?.hasSubmittedW9) {
                const hasSubmittedW9 = document.getElementById('hasSubmittedW9');
                if (hasSubmittedW9) hasSubmittedW9.checked = true;
            }

            if (broker?.canSendTextMessages) {
                const canSendTextMessages = document.getElementById('canSendTextMessages');
                if (canSendTextMessages) canSendTextMessages.checked = true;
                set_canSendTextMessages(broker.canSendTextMessages);
            }

            if (broker?.businessName) {
                set_showCompanyPanel(true);
                const doingAsCompany = document.getElementById('doingAsCompany');
                if (doingAsCompany) doingAsCompany.checked = true;

                if (broker?.title && brokerTitles.indexOf(broker?.title) === -1) {
                    set_titleSelect('Custom');
                    set_showCustomTitle(true);
                } else if (broker?.title) {
                    set_titleSelect(broker.title);
                    set_showCustomTitle(false);
                } else {
                    set_titleSelect('');
                    set_showCustomTitle(false);
                }
            } else {
                set_titleSelect('');
                set_showCustomTitle(false);
                set_showCompanyPanel(false);
            }
            set_businessName(broker?.businessName ?? '');
            set_businessState(broker?.businessState ?? '');
            set_title(broker?.title ?? '');

            if (broker?.backgroundCheckDate) {
                set_showBackgroundCheckDate(true);
                const backgroundCheckBox = document.getElementById('backgroundCheckBox');
                if (backgroundCheckBox) backgroundCheckBox.checked = true;

                set_backgroundCheckDate(new Date(broker.backgroundCheckDate));
            } else {
                set_showBackgroundCheckDate(false);
                set_backgroundCheckDate(null);
            }

            if (broker?.areTermsAccepted) set_acceptedTos(true);
            set_w9FileName(broker?.w9FileName ?? '');

            if (bfiUser.admin && broker?.lastEditJson) {
                set_lastEditJson(broker.lastEditJson);
            }

            //Set Contact Address
            const cAddress = {
                address1: broker?.businessAddress?.street1 ?? '',
                address2: broker?.businessAddress?.street2 ?? '',
                city: broker?.businessAddress?.city ?? '',
                state: broker?.businessAddress?.state ?? '',
                zipCode: broker?.businessAddress?.zipCode ?? '',
                phoneNumberA: formatPhone(broker?.phoneNumberA ?? ''),
                phoneNumberB: formatPhone(broker?.phoneNumberB ?? ''),
                phoneNumberAType: broker?.phoneNumberAType ?? '',
                phoneNumberBType: broker?.phoneNumberBType ?? '',
                email: broker?.email ?? '',
                secondaryEmail: broker?.secondaryEmail ?? '',
            };
            set_contactAddress(cAddress);

            //Set HomeAddress
            const hAddress = {
                address1: broker?.homeAddress?.street1 ?? '',
                address2: broker?.homeAddress?.street2 ?? '',
                city: broker?.homeAddress?.city ?? '',
                state: broker?.homeAddress?.state ?? '',
                zipCode: broker?.homeAddress?.zipCode ?? '',
            };
            if (broker?.dateOfBirth) {
                hAddress.dateOfBirth = new Date(broker.dateOfBirth);
            }

            const sameAsContactAddress =
                broker?.businessAddress?.street1 &&
                broker?.businessAddress?.city &&
                broker?.businessAddress?.street1 === broker?.homeAddress?.street1 &&
                broker?.businessAddress?.street2 === broker?.homeAddress?.street2 &&
                broker?.businessAddress?.city === broker?.homeAddress?.city &&
                broker?.businessAddress?.state === broker?.homeAddress?.state &&
                broker?.businessAddress?.zipCode === broker?.homeAddress?.zipCode;

            hAddress.sameAsContactAddress = sameAsContactAddress;
            set_homeAddress(hAddress);
        };

        loadBrokerAsync();
    }, [brokerState.brokerId]);

    useEffect(() => {
        if (forceValidate) {
            //See submitForm method for the explanation of this
            formRef?.current?.requestSubmit(); //triggers validation
            set_forceValidate(false); //So we don't do it again
        }
    }, [tabIndex, forceValidate]);

    const getEsignHtml = async () => {
        const response = await templatesApi.getUserAgreementHtml(0);
        if (response.statusCode !== 200) {
            return '';
        }
        return response.result;
    };

    const loadIccaTemplates = async () => {
        const response = await listApi.getIccas();

        if (response.statusCode !== 200) return;

        set_agreements(response.result);

        const defaultIcca = response.result[0];
        if (!iccaTemplateId && defaultIcca) {
            set_iccaTemplateId(defaultIcca.key);
        }
    };

    const _loadBfiEmployees = async () => {
        const data = await listApi.getBfiEmployees();
        set_pointsOfContact(data);
    };

    const _showCompanyPanelChange = () => {
        set_showCompanyPanel(!showCompanyPanel);

        set_businessState(businessState);
        set_title(title);
    };

    const _titleSelectChange = (event) => {
        const selectValue = event.target.value;

        set_showCustomTitle(selectValue === 'Custom');

        if (brokerTitles.includes(selectValue)) {
            set_title(selectValue);
            set_titleSelect(selectValue);
        } else if (selectValue === 'Custom') {
            set_titleSelect('Custom');
        } else {
            set_title(null);
            set_titleSelect(null);
        }
    };

    const _handleSubmitConfirm = async () => {
        set_openSubmitConfirm(false);
        _saveBroker();
    };

    const _handleInformW9Close = () => set_openInformW9(false);

    const _eSignAgreementChange = () => {
        const eSignAgreementCheckbox = document.getElementById('eSignAgreement');
        if (eSignAgreementCheckbox) eSignAgreementCheckbox.checked = eSignAgreement;

        set_openESignModal(true);
    };

    const _handleESignModalConfirm = (font) => {
        set_eSignFont(font.key);
        set_eSignAgreement(true);
        set_openESignModal(false);
    };

    const _handleESignModalCancel = () => {
        set_eSignAgreement(false);
        set_openESignModal(false);
    };

    const _handleActivateButton = async () => {
        try {
            set_openRejectConfirm(false);
            set_closeOnSave(false);

            if (submitForm()) {
                set_loadingMessage('Activating...');
                set_loadingOpen(true);
                let response;
                if (brokerStatus === BrokerStatusType.Rejected) {
                    response = await brokerApi.reactivateBroker(brokerState.brokerId);
                } else {
                    response = await brokerApi.activateBroker(brokerState.brokerId);
                }
                if (response.statusCode !== 200) {
                    throw new Error('Failed to activate Broker');
                }
                handleAdminSuccess('Broker activated successfully');
                _handleClose();
            }
        } catch (ex) {
            handleAdminError(ex, 'An unexpected error has occurred. Please try again.');
        } finally {
            set_loadingOpen(false);
        }
    };

    const _handleRejectButton = () => {
        set_openRejectConfirm(true);
    };

    const _handleRejectConfirm = async (comment) => {
        try {
            set_openRejectConfirm(false);
            set_closeOnSave(false);
            if (submitForm()) {
                set_loadingMessage('Rejecting...');
                set_loadingOpen(true);
                const response = await brokerApi.rejectBroker(brokerState.brokerId, comment);
                if (response.statusCode !== 200) {
                    throw new Error('Reject call failed');
                }
                handleAdminSuccess('Broker rejected successfully');
                _handleClose();
            }
        } catch (ex) {
            handleAdminError(ex, 'An unexpected error has occurred. Please try again.');
        } finally {
            set_loadingOpen(false);
        }
    };

    const _handleRejectCancel = () => {
        set_openRejectConfirm(false);
    };

    const appendFormData = (formData, name, value) => {
        if (!value || value === 'null') {
            return;
        }
        formData.append(name, value);
    };

    const _onSubmit = async (event) => {
        event.preventDefault();

        const now = new Date();
        const broker = new FormData();

        if (id) appendFormData(broker, 'id', id);
        appendFormData(broker, 'createdAt', now);
        appendFormData(broker, 'updatedAt', now);
        appendFormData(broker, 'fontId', eSignFont);

        //Broker Info
        appendFormData(broker, 'firstName', firstName);
        appendFormData(broker, 'lastName', lastName);
        appendFormData(broker, 'arizonaLicenseNumber', arizonaLicenseNumber);
        appendFormData(broker, 'wireBankName', wireBankName);
        appendFormData(broker, 'wireRecipientName', wireRecipientName);
        appendFormData(broker, 'wireAccountLastFourDigits', wireAccountLastFourDigits);
        appendFormData(broker, 'iccaTemplateId', iccaTemplateId);
        appendFormData(broker, 'clientFeeType', clientFeeType);
        appendFormData(broker, 'pointOfContactId', pointOfContactId);
        appendFormData(broker, 'hasSubmittedW9', hasSubmittedW9);
        appendFormData(broker, 'isFlagged', brokerFlagged);
        appendFormData(broker, 'w9Url', w9Url);
        appendFormData(broker, 'w9File', w9File);
        appendFormData(broker, 'businessName', businessName);
        appendFormData(broker, 'businessState', businessState);
        appendFormData(broker, 'title', title);
        if (backgroundCheckDate) appendFormData(broker, 'backgroundCheckDate', backgroundCheckDate.toLocaleDateString('en-us'));
        appendFormData(broker, 'acceptedTos', acceptedTos);

        //Contact Address
        appendFormData(broker, 'businessAddress.street1', contactAddress.address1);
        appendFormData(broker, 'businessAddress.street2', contactAddress.address2);
        appendFormData(broker, 'businessAddress.city', contactAddress.city);
        appendFormData(broker, 'businessAddress.state', contactAddress.state);
        appendFormData(broker, 'businessAddress.zipCode', contactAddress.zipCode);
        appendFormData(broker, 'phoneNumberA', contactAddress.phoneNumberA);
        appendFormData(broker, 'phoneNumberAType', contactAddress.phoneNumberAType);
        appendFormData(broker, 'phoneNumberB', contactAddress.phoneNumberB);
        appendFormData(broker, 'phoneNumberBType', contactAddress.phoneNumberBType);
        appendFormData(broker, 'email', contactAddress.email);
        appendFormData(broker, 'secondaryEmail', contactAddress.secondaryEmail);

        //Home Address
        //Have to set this manually as 'hidden' elements are not in the elements collection.
        if (homeAddress.sameAsContactAddress) {
            appendFormData(broker, 'homeAddress.street1', contactAddress.address1);
            appendFormData(broker, 'homeAddress.street2', contactAddress.address2);
            appendFormData(broker, 'homeAddress.city', contactAddress.city);
            appendFormData(broker, 'homeAddress.state', contactAddress.state);
            appendFormData(broker, 'homeAddress.zipCode', contactAddress.zipCode);
        } else {
            appendFormData(broker, 'homeAddress.street1', homeAddress.address1);
            appendFormData(broker, 'homeAddress.street2', homeAddress.address2);
            appendFormData(broker, 'homeAddress.city', homeAddress.city);
            appendFormData(broker, 'homeAddress.state', homeAddress.state);
            appendFormData(broker, 'homeAddress.zipCode', homeAddress.zipCode);
        }

        if (homeAddress.dateOfBirth) {
            appendFormData(broker, 'dateOfBirth', homeAddress.dateOfBirth.toLocaleDateString('en-us'));
        }

        appendFormData(broker, 'canSendTextMessages', canSendTextMessages);

        if (bfiUser.isBroker) {
            let ipAddressResult = '';
            const ipAddressResponse = await loginApi.getIpAddress();
            if (ipAddressResponse.statusCode === 200) {
                ipAddressResult = ipAddressResponse.result;
            }
            appendFormData(broker, 'ipAddress', ipAddressResult);
        }

        set_brokerToSave(broker);
    };

    const _saveBroker = async () => {
        handleAdminInfo('Saving broker...');

        try {
            set_loadingMessage('Saving...');
            set_loadingOpen(true);

            if (id) {
                if (bfiUser.admin) {
                    const adminAPIBrokerUpdateResponse = await brokerApi.updateAdminBroker(brokerToSave);
                    if (adminAPIBrokerUpdateResponse.statusCode !== 200) {
                        set_openBrokerUpdateError(true);
                        return;
                    }
                } else if (bfiUser.isBroker) {
                    const brokerAPIBrokerUpdateResponse = await brokerApi.updateBroker(brokerToSave);
                    if (brokerAPIBrokerUpdateResponse.statusCode !== 200) {
                        set_openBrokerUpdateError(true);
                        return;
                    }
                }
            } else {
                if (bfiUser.admin) {
                    const validateBrokerResponse = await brokerApi.validateExistingBroker(brokerToSave);
                    if (validateBrokerResponse.statusCode !== 200) {
                        return;
                    }

                    if (!validateBrokerResponse.result) {
                        set_openValidateBrokerExisting(true);
                        return;
                    }

                    const newBroker = await brokerApi.createBroker(brokerToSave);
                    if (newBroker.message && newBroker.message.includes('failed with status code')) {
                        return;
                    }
                } else {
                    throw new Error('Brokers cannot create brokers.');
                }
            }
            handleAdminSuccess('Broker saved successfully!');

            if (bfiUser.isBroker) {
                bfiUser.areTermsAccepted = true;
                bfiUser.requiresESign = false;
                dispatch(bfiUserActions.bfiUserUpdate(bfiUser));

                // TODO: can we potentially deprecate user for bfiUser in the future
                user.areTermsAccepted = true;
                user.requiresESign = false;
                dispatch(userActions.userUpdate(user));
            }

            refreshEvents.dispatchRefreshEvent();

            if (closeOnSave) {
                _handleClose();
            }
            set_closeOnSave(true);

            if (bfiUser.isBroker && !(hasSubmittedW9 || w9File || w9FileName)) set_openInformW9(true);
        } finally {
            set_loadingOpen(false);
        }
    };

    const _handleClose = () => {
        dispatch(brokerActions.setBrokerModalOpen({ openBrokerModal: false }));
    };

    const _changeClientFeeType = (event) => {
        const newValue = event.target.value;

        if (newValue === '' || newValue === '.') set_clientFeeType(newValue);

        if (isNaN(newValue)) return;

        if (newValue > 1) return;

        if (newValue < 0) return;

        set_clientFeeType(newValue);
    };

    const onContactAdressChanged = (address) => {
        if (shallowEqual(address, contactAddress)) {
            return;
        }
        set_contactAddress(address);
    };

    const onHomeAddressChanged = (address) => {
        if (shallowEqual(address, homeAddress)) {
            return;
        }
        set_homeAddress(address);
    };

    let closeButton;
    if (bfiUser.admin)
        closeButton = (
            <button
                type='button'
                className='button hollow'
                data-dismiss='modal'
                onClick={_handleClose}
                title='Cancel and changes and close dialog'
            >
                Cancel
            </button>
        );

    const styles = {
        buttonMarginRight: {
            marginRight: '10px',
        },
        hidden: {
            display: 'none',
        },
        topDisclaimer: {
            color: '#AAA',
            fontWeight: 100,
            fontSize: '1rem',
            marginBottom: '10px',
        },
        eSignCheckbox: {
            height: '25px',
            marginLeft: '20px',
        },
        textMessageCheckbox: {
            height: '15px',
            marginLeft: '20px',
        },
        checkboxLabel: {
            width: '90%',
        },
        flexDiv: {
            display: 'flex',
        },
    };

    let innerPageStyle = {};
    if (location.pathname === '/account') {
        innerPageStyle = {
            maxWidth: '996px',
            margin: '0 auto',
        };
    }

    const onDateTimeRender = (e) => {
        if (!e.value) {
            return null;
        }
        return formatDateTime(e.value);
    };

    const onStatusRender = (e) => {
        var option = BrokerStatusTypeOptions.find((a) => a.id === e.value);
        if (!option) {
            return 'Unknown';
        }
        return option.name;
    };

    const today = new Date();

    const submitForm = (e) => {
        e?.preventDefault();

        //This is a hack to get the missing fields to display and show
        //the built in Validation prompts.  Until we actually start using react-form or
        //some other form validation this is about the only way to do it.  Otherwise
        //we get a Chrome - "None focusable field with name '??' is required" message in the console, but
        //Not displayed to the user.  So this just leaved the user unable to submit and no reason why.
        if (bfiUser.admin) {
            //Validate Required fields that are in tabs - only used by admin currently
            if (!contactAddress.email) {
                //Currently only a single required field for Admin that is within a Tab
                set_forceValidate(true);
                set_tabIndex(1);
                return false;
            }
        }

        if (formRef.current.requestSubmit) {
            formRef.current.requestSubmit(); //Performs a Validation check and then a submits if passes.
        } else {
            formRef.current.submit();
        }
        return true;
    };

    return (
        <>
            <form
                name='brokerForm'
                onSubmit={(event) => _onSubmit(event)}
                ref={formRef}
            >
                <div
                    className='page-header'
                    role='banner'
                >
                    <h1 className={bfiUser.admin ? '' : 'page-header-single-h1'}>{headerText}</h1>
                    {bfiUser.admin && (
                        <button
                            type='button'
                            className='close'
                            data-dismiss='modal'
                            aria-label='Close'
                            onClick={_handleClose}
                        >
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    )}
                </div>
                <div className='main-content no-search'>
                    <div
                        className='scrollable-content'
                        style={{ padding: '10px' }}
                    >
                        <div
                            className='standard-form'
                            style={innerPageStyle}
                        >
                            <p style={styles.topDisclaimer}>
                                Brokers are not able to change all fields. They may contact BFI to request changes to those
                                fields.
                            </p>
                            <h2 className='decorated'>Broker Information</h2>
                            <div
                                className='row'
                                style={{ marginBottom: '0' }}
                            >
                                <div className='columns small-12 large-6'>
                                    <label htmlFor='firstName'>
                                        First Name
                                        <span className='req'>*</span>
                                    </label>
                                    <input
                                        id='firstName'
                                        type='text'
                                        value={firstName}
                                        onChange={(event) => set_firstName(event.target.value)}
                                        required
                                        className={!bfiUser.admin ? 'readOnly' : ''}
                                        readOnly={!bfiUser.admin}
                                    />
                                    <span className='helper'>
                                        <span className='tooltip-trigger'>
                                            <FontAwesomeIcon icon={faCircleQuestion} />
                                        </span>
                                        <span className='text'>Your first name (e.g. John)</span>
                                    </span>
                                </div>
                                <div className='columns small-12 large-6'>
                                    <label htmlFor='lastName'>
                                        Last Name
                                        <span className='req'>*</span>
                                    </label>
                                    <input
                                        id='lastName'
                                        type='text'
                                        value={lastName}
                                        onChange={(event) => set_lastName(event.target.value)}
                                        required
                                        className={!bfiUser.admin ? 'readOnly' : ''}
                                        readOnly={!bfiUser.admin}
                                    />
                                    <span className='helper'>
                                        <span className='tooltip-trigger'>
                                            <FontAwesomeIcon icon={faCircleQuestion} />
                                        </span>
                                        <span className='text'>Your last name (e.g. Smith)</span>
                                    </span>
                                </div>
                                <div className='columns small-12 large-6'>
                                    <label htmlFor='arizonaLicenseNumber'>Arizona License Number</label>
                                    <input
                                        id='arizonaLicenseNumber'
                                        type='text'
                                        value={arizonaLicenseNumber}
                                        onChange={(event) => set_arizonaLicenseNumber(event.target.value)}
                                    />
                                    <span className='helper'>
                                        <span className='tooltip-trigger'>
                                            <FontAwesomeIcon icon={faCircleQuestion} />
                                        </span>
                                        <span className='text'>
                                            If you will broker deals in Arizona, please provide your license number.
                                        </span>
                                    </span>
                                </div>
                                {bfiUser.admin && (
                                    <>
                                        <div className='columns small-12 medium-6'>
                                            <label htmlFor='iccaId'>
                                                Agreement Version for This Broker
                                                <span className='req'>*</span>
                                            </label>
                                            <select
                                                id='iccaId'
                                                value={iccaTemplateId}
                                                onChange={(event) => set_iccaTemplateId(event.target.value)}
                                                required
                                            >
                                                {agreements &&
                                                    agreements.map((agreement) => {
                                                        return (
                                                            <option
                                                                key={agreement.key}
                                                                value={agreement.key}
                                                            >
                                                                {agreement.name}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                        </div>

                                        <div className='columns small-12 medium-6'>
                                            <label htmlFor='clientFeeType'>Expected Client Fee %</label>
                                            <input
                                                id='clientFeeType'
                                                type='number'
                                                min='0'
                                                max='1'
                                                step='.01'
                                                value={clientFeeType}
                                                onChange={_changeClientFeeType}
                                            />
                                            <span className='helper'>
                                                <span className='tooltip-trigger'>
                                                    <FontAwesomeIcon icon={faCircleQuestion} />
                                                </span>
                                                <span className='text'>
                                                    Client Fee is money paid by B-Client to Broker. A Client Fee is an additional
                                                    cost added to closing statement(s). Note that the BFI Share is money paid by
                                                    BFI to Broker out of BFI’s upfront points.
                                                </span>
                                            </span>
                                        </div>
                                        <div className='columns small-12 medium-6'>
                                            <label htmlFor='pointOfContact'>
                                                Point of Contact
                                                <span className='req'>*</span>
                                            </label>
                                            <select
                                                id='pointOfContact'
                                                value={pointOfContactId}
                                                onChange={(event) => set_pointOfContactId(event.target.value)}
                                                required
                                            >
                                                <option
                                                    key=''
                                                    value=''
                                                ></option>
                                                {pointsOfContact &&
                                                    pointsOfContact.map((poc) => {
                                                        return (
                                                            <option
                                                                key={poc.key}
                                                                value={poc.key}
                                                            >
                                                                {poc.name}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                        </div>

                                        <div className='columns small-12 medium-3'>
                                            <input
                                                id='hasSubmittedW9'
                                                type='checkbox'
                                                value={hasSubmittedW9}
                                                onChange={(event) => set_hasSubmittedW9(event.target.checked)}
                                            />
                                            <label htmlFor='hasSubmittedW9'>
                                                W-9 on file
                                                {w9Url && (
                                                    <>
                                                        {' '}
                                                        (<a href={w9Url}>download W9</a>)
                                                    </>
                                                )}
                                            </label>
                                        </div>
                                    </>
                                )}
                                {bfiUser.admin && (
                                    <div className='columns small-12 medium-3'>
                                        <input
                                            id='brokerFlagged'
                                            type='checkbox'
                                            checked={brokerFlagged === true}
                                            onChange={(event) => set_brokerFlagged(event.target.checked)}
                                        />
                                        <label htmlFor='brokerFlagged'>Broker is Flagged</label>{' '}
                                        {brokerFlagged && (
                                            <FontAwesomeIcon
                                                style={{ color: 'darkred' }}
                                                icon={faFlag}
                                            />
                                        )}
                                    </div>
                                )}
                                {bfiUser.admin && (
                                    <div className='columns small-12 medium-3'>
                                        <input
                                            id='backgroundCheckBox'
                                            type='checkbox'
                                            onChange={() => set_showBackgroundCheckDate(!showBackgroundCheckDate)}
                                        />
                                        <label htmlFor='validBackgroundCheck'>Clean background</label>
                                    </div>
                                )}

                                <div className='columns small-12'>
                                    <input
                                        id='doingAsCompany'
                                        type='checkbox'
                                        onChange={_showCompanyPanelChange}
                                    />
                                    <label htmlFor='doingAsCompany'>Doing this as a company</label>
                                </div>

                                {showCompanyPanel ? (
                                    <div className='columns small-12 medium-12'>
                                        <fieldset className='shaded'>
                                            <div className='row'>
                                                <div className='columns small-12 large-6'>
                                                    <label htmlFor='businessName'>
                                                        Legal Name of Entity
                                                        <span className='req'>*</span>
                                                    </label>
                                                    <input
                                                        id='businessName'
                                                        type='text'
                                                        value={businessName}
                                                        onChange={(event) => set_businessName(event.target.value)}
                                                        required={true}
                                                    />
                                                    <span className='helper'>
                                                        <span className='tooltip-trigger'>
                                                            <FontAwesomeIcon icon={faCircleQuestion} />
                                                        </span>
                                                        <span className='text'>e.g. The Referral Company, LLC</span>
                                                    </span>
                                                </div>
                                                <div className='columns small-12 medium-6 large-3'>
                                                    <label htmlFor='businessState'>
                                                        State of Incorporation
                                                        <span className='req'>*</span>
                                                    </label>
                                                    <StateSelect
                                                        id='businessState'
                                                        value={businessState}
                                                        onChange={(event) => set_businessState(event.target.value)}
                                                        required={true}
                                                    />
                                                    <span className='helper'>
                                                        <span className='tooltip-trigger'>
                                                            <FontAwesomeIcon icon={faCircleQuestion} />
                                                        </span>
                                                        <span className='text'>State where the company was registered</span>
                                                    </span>
                                                </div>
                                                <div className='columns small-12 medium-6 large-3'>
                                                    <label htmlFor='brokerTitle'>
                                                        Broker&apos;s Title at Company
                                                        <span className='req'>*</span>
                                                    </label>
                                                    <select
                                                        id='title'
                                                        value={titleSelect}
                                                        onChange={_titleSelectChange}
                                                        required={true}
                                                    >
                                                        <option value=''>Select</option>
                                                        {brokerTitles.map((title) => {
                                                            return (
                                                                <option
                                                                    key={title}
                                                                    value={title}
                                                                >
                                                                    {title}
                                                                </option>
                                                            );
                                                        })}
                                                        <option
                                                            key='Custom'
                                                            value='Custom'
                                                        >
                                                            Custom
                                                        </option>
                                                    </select>
                                                    <span className='helper'>
                                                        <span className='tooltip-trigger'>
                                                            <FontAwesomeIcon icon={faCircleQuestion} />
                                                        </span>
                                                        <span className='text'>State where the company was registered</span>
                                                    </span>
                                                    <span className='helper'>
                                                        <span className='tooltip-trigger'>
                                                            <FontAwesomeIcon icon={faCircleQuestion} />
                                                        </span>
                                                        <span className='text'>
                                                            Broker&apos;s title at the company being paid/listed below
                                                        </span>
                                                    </span>
                                                </div>
                                                {showCustomTitle ? (
                                                    <div className='columns small-12'>
                                                        <label htmlFor='title'>
                                                            Custom Broker Title
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <input
                                                            id='title'
                                                            type='text'
                                                            value={title}
                                                            onChange={(event) => set_title(event.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                ) : null}
                                            </div>
                                        </fieldset>
                                    </div>
                                ) : null}

                                {showBackgroundCheckDate ? (
                                    <div className='columns small-12 medium-3'>
                                        <label htmlFor='backgroundCheckDate'>
                                            Date of Background Check
                                            <span className='req'>*</span>
                                        </label>
                                        <DatePicker
                                            id='backgroundCheckDate'
                                            selected={backgroundCheckDate}
                                            onChange={(date) => set_backgroundCheckDate(date)}
                                            required={true}
                                            maxDate={today}
                                        />
                                    </div>
                                ) : null}
                            </div>
                            <h2 className='decorated'>Bank Wire Information</h2>
                            <div
                                className='row'
                                style={{ marginBottom: '0' }}
                            >
                                <div className='columns  small-12 large-6'>
                                    <label htmlFor='wireBankName'>Bank Name</label>
                                    <input
                                        id='wireBankName'
                                        type='text'
                                        value={wireBankName}
                                        onChange={(event) => set_wireBankName(event.target.value)}
                                    />
                                    <span className='helper'>
                                        <span className='tooltip-trigger'>
                                            <FontAwesomeIcon icon={faCircleQuestion} />
                                        </span>
                                        <span className='text'>Name of the bank you wish to wire funds to.</span>
                                    </span>
                                </div>
                                <div className='columns  small-12 large-6'>
                                    <label htmlFor='wireRecipientName'>Recipient Name</label>
                                    <input
                                        id='wireRecipientName'
                                        type='text'
                                        value={wireRecipientName}
                                        onChange={(event) => set_wireRecipientName(event.target.value)}
                                    />
                                    <span className='helper'>
                                        <span className='tooltip-trigger'>
                                            <FontAwesomeIcon icon={faCircleQuestion} />
                                        </span>
                                        <span className='text'>The name on the bank account.</span>
                                    </span>
                                </div>
                                {/* <div className="columns  small-12 large-6">
                      <label htmlFor="wireAccountLastFourDigits">
                          Last four digits of Account #
                      </label>
                      <input id="wireAccountLastFourDigits" type="text" maxLength={4} minLength={4} value={wireAccountLastFourDigits} onChange={(event) => set_wireAccountLastFourDigits(event.target.value)} />
                      <span className="helper">
                          <span className="tooltip-trigger"><FontAwesomeIcon icon={faCircleQuestion}/></span>
                          <span className="text">The last four digits of your account #, please provide the full number to BFI directly.</span>
                      </span>
                  </div> */}
                            </div>
                            {bfiUser.isBroker && (
                                <>
                                    <h2 className='decorated'>Contact Address</h2>
                                    <ContactAddress
                                        id={id}
                                        address={contactAddress}
                                        brokerStatus={brokerStatus}
                                        lastEditJson={lastEditJson}
                                        bfiUser={bfiUser}
                                        onChange={onContactAdressChanged}
                                    />

                                    <h2 className='decorated'>Home Address</h2>
                                    <HomeAddress
                                        address={homeAddress}
                                        brokerStatus={brokerStatus}
                                        lastEditJson={lastEditJson}
                                        bfiUser={bfiUser}
                                        onChange={onHomeAddressChanged}
                                    />
                                </>
                            )}

                            {!bfiUser.isBroker && (
                                <>
                                    <h2 className='decorated'>Additional Information</h2>
                                    <TabPanel
                                        tabsPosition={'left'}
                                        height={450}
                                        onSelectionChanged={onTabClicked}
                                        selectedIndex={tabIndex}
                                    >
                                        <Item
                                            title={tabNames[0]}
                                            visible={brokerStatus === BrokerStatusType.Activated}
                                        >
                                            <div style={{ padding: '10px' }}>
                                                <BrokerClientsTable brokerId={brokerState.brokerId} />
                                            </div>
                                        </Item>
                                        <Item title={tabNames[1]}>
                                            <div style={{ padding: '10px' }}>
                                                <ContactAddress
                                                    id={id}
                                                    address={contactAddress}
                                                    brokerStatus={brokerStatus}
                                                    lastEditJson={lastEditJson}
                                                    bfiUser={bfiUser}
                                                    onChange={onContactAdressChanged}
                                                    highlightDiffs={highlightDiffs}
                                                />
                                            </div>
                                        </Item>
                                        <Item title={tabNames[2]}>
                                            <div style={{ padding: '10px' }}>
                                                <HomeAddress
                                                    address={homeAddress}
                                                    brokerStatus={brokerStatus}
                                                    lastEditJson={lastEditJson}
                                                    bfiUser={bfiUser}
                                                    onChange={onHomeAddressChanged}
                                                    highlightDiffs={highlightDiffs}
                                                />
                                            </div>
                                        </Item>
                                        <Item
                                            title={tabNames[3]}
                                            visible={id > 0 && bfiUser.admin}
                                        >
                                            <div style={{ padding: '10px' }}>
                                                <BfiDataGrid
                                                    dataSource={statusHistory}
                                                    keyExpr='id'
                                                    showBorders={true}
                                                    showRowLines={false}
                                                    rowAlternationEnabled={true}
                                                    remoteOperations={false}
                                                    allowColumnReordering={true}
                                                    allowColumnResizing={true}
                                                    noDataText='No Status History available'
                                                    defaultPageSize={12}
                                                    allowedPageSizes={[12]}
                                                    applicationInsights={applicationInsights}
                                                    gridType={GridSettingType.BrokerStatusHistory}
                                                >
                                                    <Column
                                                        dataField='statusId'
                                                        caption='Status'
                                                        width={200}
                                                        cellRender={onStatusRender}
                                                        alignment={'left'}
                                                    />
                                                    <Column
                                                        dataField='createdAt'
                                                        caption='On'
                                                        width={150}
                                                        cellRender={onDateTimeRender}
                                                        alignment={'left'}
                                                    />
                                                    <Column
                                                        dataField='createdBy'
                                                        caption='By'
                                                        width={300}
                                                        alignment={'left'}
                                                    />
                                                </BfiDataGrid>
                                            </div>
                                        </Item>
                                        <Item
                                            title={tabNames[4]}
                                            visible={id > 0 && bfiUser.admin}
                                        >
                                            <div style={{ padding: '10px' }}>
                                                <UserAgreementsTable id={id} />
                                            </div>
                                        </Item>
                                    </TabPanel>
                                </>
                            )}

                            {bfiUser.isBroker && (
                                <>
                                    {!hasSubmittedW9 && !w9FileName && (
                                        <>
                                            <h2 className='decorated'>W9 File</h2>
                                            <div className='row'>
                                                <div className='columns small-12'>
                                                    <label htmlFor='w9File'>W9 File Uploaded:</label>
                                                    <input
                                                        type='file'
                                                        id='w9File'
                                                        onChange={(event) => set_w9File(event.target.files[0])}
                                                    />
                                                    <div
                                                        style={{
                                                            marginBottom: '1rem',
                                                        }}
                                                    >
                                                        <a
                                                            href='https://www.irs.gov/pub/irs-pdf/fw9.pdf'
                                                            target='_blank'
                                                            rel='noreferrer'
                                                        >
                                                            For a blank W9 follow this link
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {w9FileName && (
                                        <>
                                            <h2 className='decorated'>W9 File</h2>
                                            <div className='row'>
                                                <div className='columns small-12'>
                                                    <label htmlFor='w9File'>Uploaded W9 File:</label>
                                                    <p>{w9FileName}</p>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {hasSubmittedW9 && (
                                        <>
                                            <h2 className='decorated'>W9 File</h2>
                                            <div className='row'>
                                                <div className='columns small-12'>
                                                    <p>
                                                        We have a W9 on file for you. If it needs to be updated, please email an
                                                        updated W9 separately.
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div>
                                        <div>
                                            <div style={styles.flexDiv}>
                                                <input
                                                    id='eSignAgreement'
                                                    style={styles.eSignCheckbox}
                                                    type='checkbox'
                                                    onChange={(event) => _eSignAgreementChange(event)}
                                                />
                                                <label
                                                    htmlFor='eSignAgreement'
                                                    style={styles.checkboxLabel}
                                                >
                                                    Consent to Use Electronic Records and Disclosures. By checking this check box
                                                    and clicking "SAVE", I acknowledge that I have read and agree on behalf of the
                                                    Business Entities to the Consent to Use Electronic Records and Disclosures.
                                                </label>
                                            </div>
                                            <div style={styles.flexDiv}>
                                                <input
                                                    id='canSendTextMessages'
                                                    style={styles.textMessageCheckbox}
                                                    type='checkbox'
                                                    value={canSendTextMessages}
                                                    onChange={(event) => set_canSendTextMessages(event.target.checked)}
                                                />
                                                <label
                                                    htmlFor='canSendTextMessages'
                                                    style={styles.checkboxLabel}
                                                >
                                                    I consent to receive text messages
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        <div
                            className='button-footer'
                            style={innerPageStyle}
                        >
                            {bfiUser.admin &&
                            (brokerStatus === BrokerStatusType.InviteAccepted || brokerStatus === BrokerStatusType.Rejected) ? (
                                <>
                                    <button
                                        style={styles.buttonMarginRight}
                                        type='button'
                                        className='button primary'
                                        onClick={_handleActivateButton}
                                        disabled={!hasPermission(PermissionType.BrokerApproveReject)}
                                    >
                                        {brokerStatus === BrokerStatusType.Rejected ? 'Re-Activate' : 'Activate'}
                                    </button>
                                    {brokerStatus === BrokerStatusType.InviteAccepted && (
                                        <button
                                            style={styles.buttonMarginRight}
                                            type='button'
                                            className='button redButton'
                                            onClick={_handleRejectButton}
                                            disabled={!hasPermission(PermissionType.BrokerApproveReject)}
                                        >
                                            Reject
                                        </button>
                                    )}
                                    {closeButton}
                                    <button
                                        style={styles.hidden}
                                        type='button'
                                        className='button primary'
                                        ref={submitRef}
                                        onClick={(e) => submitForm(e)}
                                    >
                                        Save
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button
                                        style={styles.buttonMarginRight}
                                        type='button'
                                        className='button primary'
                                        disabled={bfiUser.isBroker && !eSignAgreement}
                                        onClick={(e) => submitForm(e)}
                                    >
                                        Save
                                    </button>
                                    {closeButton}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </form>
            <ConfirmModal
                isOpen={openSubmitConfirm}
                text='If all information supplied is accurate, click submit to finish and submit the file to BFI for review & approval.'
                confirmCallback={_handleSubmitConfirm}
                cancelCallback={() => set_openSubmitConfirm(false)}
                confirmButtonText='Submit'
            />
            <InformModal
                isOpen={openInformW9}
                title='W-9 Required'
                text='We need a copy of your W-9, please send it to the following email address: referral@builderfinance.com'
                confirmCallback={_handleInformW9Close}
            />
            <InformModal
                isOpen={openValidateBrokerExisting}
                title='Duplicate Broker!'
                text='The Email Address that you have entered already exists in the database.'
                confirmCallback={() => set_openValidateBrokerExisting(false)}
            />
            <InformModal
                isOpen={openBrokerUpdateError}
                title='Unable to Update Broker'
                text='There was an error submitting your request, please refresh your browser and try again.<br><br>If the error persists, please contact team@builderfinance.com.'
                confirmCallback={() => set_openBrokerUpdateError(false)}
            />
            <ESignModal
                isOpen={openESignModal}
                confirmCallback={(font) => _handleESignModalConfirm(font)}
                cancelCallback={() => _handleESignModalCancel()}
                signatureText={`${firstName} ${lastName}`}
                agreementHtml={userAgreementHtml}
            />
            <RejectConfirmModal
                isOpen={openRejectConfirm}
                confirmCallback={_handleRejectConfirm}
                cancelCallback={_handleRejectCancel}
            />
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
        </>
    );
};

export default BrokerDetails;
